import { HeadingTypeEnum } from 'common/enums/HeadingTypeEnum'

export const headingFontSize: Record<
  HeadingTypeEnum,
  { fontSize: number; lineHeight: number }
> = {
  [HeadingTypeEnum.HeaderOne]: { fontSize: 36, lineHeight: 44 },
  [HeadingTypeEnum.HeaderTwo]: { fontSize: 30, lineHeight: 38 },
  [HeadingTypeEnum.HeaderThree]: { fontSize: 24, lineHeight: 32 },
  [HeadingTypeEnum.HeaderFour]: { fontSize: 20, lineHeight: 28 },
  [HeadingTypeEnum.HeaderFive]: { fontSize: 18, lineHeight: 24 },
  [HeadingTypeEnum.HeaderSix]: { fontSize: 16, lineHeight: 22 },
}

export const mobileHeadingFontSize: Record<
  HeadingTypeEnum,
  { fontSize: number; lineHeight: number }
> = {
  [HeadingTypeEnum.HeaderOne]: { fontSize: 28, lineHeight: 34 },
  [HeadingTypeEnum.HeaderTwo]: { fontSize: 24, lineHeight: 30 },
  [HeadingTypeEnum.HeaderThree]: { fontSize: 20, lineHeight: 26 },
  [HeadingTypeEnum.HeaderFour]: { fontSize: 18, lineHeight: 24 },
  [HeadingTypeEnum.HeaderFive]: { fontSize: 16, lineHeight: 22 },
  [HeadingTypeEnum.HeaderSix]: { fontSize: 14, lineHeight: 20 },
}
